<div class="tw-pb-2">
  <h2>Close All Tabs?</h2>
  <mat-dialog-actions class="tw-justify-end">
    <button mat-button type="button" (click)="cancel.emit()"mat-dialog-close>Cancel</button>
    <button mat-raised-button type="button" color="primary" (click)="confirm.emit()">Yes</button>
  </mat-dialog-actions>
</div>
